import React, { useRef, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import PropTypes from 'prop-types';

// Import Swiper styles
import "swiper/css";
import 'swiper/css/scrollbar';
// import 'swiper/css/lazy';

import Css from "./SwiperSlideDevMoby.module.css";

// import required modules
import SwiperCore, { Scrollbar, Lazy } from "swiper/modules";



export const SwiperSlideDevMoby = (ImagesItems, ...props) => {
  // SwiperCore.use([Lazy]);
  return (
    <div className={Css.rootSlide}>
      <Swiper
        direction={"horizontal"}
        slidesPerView={1}
        modules={[Scrollbar]}
        className={Css.mySwiper}
        scrollbar={{ draggable: true }}
        // lazy={true} className='swiper-lazy'
      >
        {ImagesItems.ImagesItems.map((item, index) => {
          return (
            <SwiperSlide key={index}  >
            <img src={item}  />
            {/* <div className="swiper-lazy-preloader" /> */}
          </SwiperSlide>
          )

        })}

      </Swiper>
    </div>
  );
}
